import React from 'react';
import PropTypes from 'prop-types';
import * as HelperCanvas from '../../utils/HelperCanvas';

import {
  squareSize, grassMod
} from '../../utils/Constant'


class Canvas extends React.Component {

  constructor(props) {

    super(props);

    if (!props) {
      props = {}
    }
    this.state = {
      style: {
        position: 'absolute',
      },
      customizeMode: true,
      offset: props.offset || {x: 0, y: 0},
      loaded: false,
      square: squareSize,
      grassMod: grassMod,
      lineWidth: 8,
      halfSquare: Math.floor(squareSize / 2),
      selected: null,
      position: props.position
    };

  }

  tile = (cimage, x, y, width, height) => {

    if(!cimage) {
      return [];
    }

    let by_x, by_y, _i, _results, _x, _y;
    by_x = Math.floor(width / cimage.width);
    by_y = Math.floor(height / cimage.height);

    if (cimage && !isNaN(by_x) && !isNaN(by_y)) {

      _results = [];

      for (_x = _i = 0; _i < by_x; _x = _i += 1) {
        let _j, _results1;

        _results1 = [];
        for (_y = _j = 0; _j < by_y; _y = _j += 1) {
          _results1.push(this.ctx.drawImage(cimage, x + _x * cimage.width, y + _y * cimage.height));
        }
        _results.push(_results1);
      }

      return _results;
    }
    return [];
  };

  getCtx = () => {
    return this.props.getCtx(this.ctx);
  };

  getRealCoordinates = (coordinates = this.props.coordinates) => {

    const {square, grassMod} = this.state;
    return coordinates && coordinates.map((coord) => {
      if (coord) {
        return {
          x: coord.x * square + square * grassMod,
          y: coord.y * square + square * grassMod
        }
      } else {
        return {};
      }
    });
  };

  getElementPosition = (element) => {
    let curleft, curtop;
    curleft = 0;
    curtop = 0;
    if (element.offsetParent) {
      while (true) {
        curleft += element.offsetLeft;
        if (!element.offsetParent) {
          break;
        }
        element = element.offsetParent;
      }
    } else {
      if (element.x) {
        curleft += element.x;
      }
    }
    if (element.offsetParent) {
      while (true) {
        curtop += element.offsetTop;
        if (!element.offsetParent) {
          break;
        }
        element = element.offsetParent;
      }
    } else {
      if (element.y) {
        curtop += element.y;
      }
    }
    return {
      x: curleft,
      y: curtop
    };
  };

  isHit = (x, y) => {
    this.ctx.globalCompositeOperation = "source-over";
    const {square, grassMod} = this.state;
    const {field} = this.props;
    this.ctx.rect(0, 0, field.width * square + square * grassMod * 2, field.height * square + square * grassMod * 2);
    return this.ctx.isPointInPath(x, y);
  };

  moveTo = (x = this.props.position.x, y = this.props.position.y) => {
    this.props.moveTo(x, y);
  };

  clear = (full = false) => {
    if (full) {
      this.ctx.restore();
      this.ctx.clearRect(0, 0, this.getScaledWidth(), this.getScaledHeight());
      this.ctx.save();
    } else {
      this.ctx.restore();
      const position = this.getScaledPosition();
      this.ctx.clearRect(position.x, position.y, position.x + this.getScaledWidth(), position.y + this.getScaledHeight());
      return this.ctx.save();
    }
  };

  getScaledWidth = (scale = this.props.sizes.scale) => {
    return this.props.sizes.width / scale;
  };

  getScaledHeight = (scale = this.props.sizes.scale) => {
    return this.props.sizes.height / scale;
  };

  getScaledPosition = (scale = this.props.sizes.scale) => {
    return {
      x: this.props.position.x / scale,
      y: this.props.position.y / scale
    };
  };

  getOffsetXY = (x, y) => {
    return {
      x: x - this.props.offset.x,
      y: y - this.props.offset.y
    }
  };


  //Применение обратной трансформации с переворотом по Y и вращением на 90
  backTransformWithFlipAndRotate(x, y, scale) {
  //Распишем ход трансформации:
    // //Начинаем с зеркалирования "y"
    // this.ctx.transform(1, 0, 0, -1, 0, 0); //(Y теперь с "-")
    // //поворачиваем на угол 90 из-за хитрого построения изо-площадки:
    // this.ctx.rotate(Math.PI * 90/180);
    // //(x и y поменялись местами, причем X теперь еще и унаследовал минус от Y)
    // //Сдвигаем (помним что x и y поменяны местами.
    // //(+Y = это влево, -Y вправо, X - должен быть вниз, но засчет унаследованного минуса, теперь это вверх. -X вниз)
    // this.ctx.translate(-y, -x); //вправо и вниз
    // //Еще помним, что х и y - это координаты "обратные" к изоплощадке.
    // //Причем для оборудования они дополнительно повернуты на 90 град (baseX+shiftY, baseY+shiftX).
    // //И доворачиваем все это дело еще на 180
    // this.ctx.rotate(Math.PI);

  // После вышеописанного разжевывания, в сокращенном варианте:
    this.ctx.transform(1, 0, 0, -1, x, y);
    this.ctx.rotate(Math.PI * 270/180);

    //Значения сдвига левого верхнего угла площадки viewTop к углу изометрической площадки (разница на ширину травы):
    //ширину травы считаем постоянной и сдвиг тогда приблизительно такой:
    let viewTopShift = {x: 45, y: -80};
    this.ctx.translate(viewTopShift.y * scale, viewTopShift.x * scale); //(y -x)
  }

  //экспериментальное рисование (до трансформации канваса)
  checkCorrectBackTransform1(x, y, baseX, baseY, viewTopShift, a, b, c, d, scale) {
    //две большие коричневые точки - исходная линия.
    //нарисованая линия - изо преобразование (по аналогии как строилась площадка по a,b,c,d)
    //маленькая точка обратное преобразование конца изо линии. Должно совпасть с второй точкой - концом исходной линии.

    baseX *= scale;
    baseY *= scale;

    let tempX = 0;  //начало рисования исходной линии относительно baseXY
    let tempY = 0;

    //за ненадобностью пока сбросим персональный сдвиг
    viewTopShift = {x:0, y:0};

    //1-я точка базовая
    this.ctx.fillStyle = '#80555F';
    this.ctx.fillRect(tempX + baseX + viewTopShift.x - 2, tempY + baseY + viewTopShift.y - 2, 10, 10);

    //1-я точка изо линии (там же)
    this.ctx.beginPath();
    //let tempIzo = HelperCanvas.calculateEmulateTransformWithFlip(tempX, tempY, a, b, c, d, baseY + viewTopShift.y, scale);
//    let tempIzo = HelperCanvas.calculateEmulateTransform(tempX, tempY, a, b, c, d, scale);
    //this.ctx.moveTo(tempIzo.x + baseX + viewTopShift.x, tempIzo.y + baseY + viewTopShift.y);

    let tempIzo = HelperCanvas.calculateEmulateTransformWithFlipAndRotate(baseX + viewTopShift.x, baseY + viewTopShift.y, tempX, tempY, a, b, c, d, baseY + viewTopShift.y, scale);
    this.ctx.moveTo(tempIzo.x , tempIzo.y);

    //2-я точка базовая
    //tempX += 100 * scale;
    tempY += 200 * scale;
    this.ctx.fillStyle = '#80555F';
    this.ctx.fillRect(tempX + baseX + viewTopShift.x, tempY + baseY + viewTopShift.y, 10, 10);

    //2-я точка изолинии
    //tempIzo = this.calculateEmulateTransformWithFlip(tempX, tempY, a, b, c, d, baseY + viewTopShift.y);
   //  tempIzo = HelperCanvas.calculateEmulateTransform(tempX, tempY, a, b, c, d, scale);
    // this.ctx.lineTo(tempIzo.x + baseX + viewTopShift.x, tempIzo.y + baseY + viewTopShift.y);

    tempIzo = HelperCanvas.calculateEmulateTransformWithFlipAndRotate(baseX + viewTopShift.x, baseY + viewTopShift.y, tempX, tempY, a, b, c, d, baseY + viewTopShift.y, scale);
    this.ctx.lineTo(tempIzo.x, tempIzo.y);

    this.ctx.stroke();
//    console.log('tempXIzo', tempIzo.x, tempIzo.y);

    //обратное преобразование конца изо линии (должны попасть в базовую точку 2):
    let backTempX = HelperCanvas.calculateBackTransform(tempIzo.x, tempIzo.y, a, b, c, d, scale);
    this.ctx.fillStyle = '#80000F';
    this.ctx.fillRect(backTempX.x + baseX + viewTopShift.x, backTempX.y + baseY + viewTopShift.y, 5, 5);
//    console.log('tempX', backTempX.x, backTempX.y);


 //Рисуем розовый квадратик начала изо площадки
  this.ctx.fillStyle = '#DD00FF';
  this.ctx.fillRect(baseX, baseY, 20, 20);

//Рисуем синие точки левого верхнего угла изо кртинки
  this.ctx.fillStyle = '#0000FF';
  this.ctx.fillRect(x * scale, y * scale, 10, 10);
}

//экспериментальные рисовалки после трансформации канваса
checkCorrectBackTransform2(x, y, baseX, baseY, viewTopShift, a, b, c, d, scale) {
  //Рисуем зеленые большие квадратики в точке 0,0, т.е. куда довертели канвас. Это середина viewTop картинки
  this.ctx.fillStyle = '#668800';
  this.ctx.fillRect(0, 0, 15, 15);
}

//экспериментальные рисовалки 3
checkCorrectBackTransform3(x, y, baseX, baseY, scale, image) {
  //Зеленые маленькие квадратики в левом верхнем углу картинки (после флипа и ротации на 90, => стал правый верхний)
  this.ctx.fillStyle = '#00ff00';
  this.ctx.fillRect(0, 0, 8, 8);
//  this.ctx.drawImage(image, x, y); не рисует
}

}

Canvas.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Canvas;

